import {
  Customer,
  CustomerHierarchy,
  CustomersData,
  CustomerInspectors,
  Inspector,
} from '@/types';
import {
  Core,
  CUSTOMER_HIERARCHY,
  CUSTOMER_INSPECTOR,
  CUSTOMER_SITE_AND_INSPECTORS,
  CUSTOMERS,
  USERS,
} from '../Core';

class Customers extends Core {
  getCustomers = async () => this.get<Customer[]>(CUSTOMERS());

  getCustomersHierarchy = async () =>
    this.get<CustomerHierarchy[]>(CUSTOMER_HIERARCHY());

  getCustomerInspectors = async () =>
    this.get<CustomerInspectors[]>(CUSTOMER_SITE_AND_INSPECTORS());

  getUserCustomers = async (userId?: number) =>
    this.get<CustomersData>(`${USERS(userId)}/customers`);

  createCustomer = async (data: Customer) => this.post(CUSTOMERS(), data);

  updateCustomer = async (data: Customer) => this.patch(CUSTOMERS(), data);

  createInspector = async (data: Inspector) =>
    this.post(CUSTOMER_INSPECTOR(), data);
}

export const customers = new Customers();
